import React from 'react'

import NavigationMenu_ItemProjectWithReorder from "../../menu-items/project/menu-item-project-with-reorder"
import NavigationMenu_ProjectsLocalSettings from "../../local-settings"
import ProjectSession from "../../../../core/model2/project/project-session"
import {SpaceProto} from "../../../../core/model2/space/space-proto"
import {menu_sortProjects} from "../../menu-items/project/functions/order-projects"

type Props = {
    level           : number
    parentId        : string
    projects        : ProjectSession[]
    localSettings   : NavigationMenu_ProjectsLocalSettings
    space           : SpaceProto
}

// const debug = "ProjectsReorderList"
const debug = false

// One nesting level of the tree. Drag and drop is handled per row by MenuProject_DndItem against the
// single manager MenuProjects_DndRoot puts in context, so this only has to order and render.
export default class ProjectsReorderList extends React.Component<Props> {

    render() {
        debug && console.log(debug, 'render() localSettings=', this.props.localSettings)

        const projects = _.filter(menu_sortProjects(this.props.projects, this.props.space), (project: ProjectSession) => {
            if (project.isArchived) {
                return false
            }

            // if no access and no child project that requires to show all parents then skip this project
            return !!project.access || !!project.treeChildren
        })

        debug && console.log(debug, '    projects=', projects)

        return (
            <>
                {_.map(projects, (project: ProjectSession) => {
                    return (
                        <NavigationMenu_ItemProjectWithReorder
                            key                         = {project.id}
                            level                       = {this.props.level}
                            project                     = {project}
                            space                       = {this.props.space}
                            parentId                    = {this.props.parentId}
                            siblings                    = {projects}
                            localSettings               = {this.props.localSettings}
                            expandedProjectsSettingName = "expandedProjects"
                        />
                    )
                })}
            </>
        )
    }
}
